const parseDate = dateStr => {
    const [y, m, d] = String(dateStr || '').split('-').map(Number);
    if (!y || !m || !d) return null;
    const date = new Date(y, m - 1, d);
    date.setHours(0, 0, 0, 0);
    return date;
};

export function calcStreak(records = [], fromDate = new Date()) {
    if (!records.length) return 0;
    const days = [...new Set(records.map(r => r.date).filter(Boolean))].sort().reverse();
    const start = new Date(fromDate);
    start.setHours(0, 0, 0, 0);

    let streak = 0;
    for (let i = 0; i < days.length; i += 1) {
        const rd = parseDate(days[i]);
        if (!rd) continue;
        if (Math.round((start - rd) / 86400000) === i) streak += 1;
        else break;
    }
    return streak;
}
